import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class strings safely.
 *
 * Uses `clsx` for conditional/array composition and `tailwind-merge` to
 * resolve conflicts (e.g. `cn("p-4", "p-6")` → `"p-6"`).
 *
 * Required by every shadcn primitive.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
